<template>
  <div :class="{ 'wire': true, 'vpc': true, 'd-flex': true, 'common': true, pointer: ['vminstance', 'gpu'].includes(type) }" @click="handleClick">
    <span class="line" />
    <div :class="{'common-left-line': showLeftLine}" />
    <div class="text-center" :class="{'res-running': type === 'vminstance' && dataSource.status === 'running' ? 'res-running' : ''}">
      <tooltip v-if="tooltipShow">
        <template slot="title">
          {{ $t(`network.topology.res_type.${nameType}`) }}
        </template>
        <template slot="content">
          <p>{{ $t('common.name') }}：{{ dataSource.name }}</p>
          <p v-if="type !== 'gpu'">{{ $t('common.status') }}：{{ getStatus(dataSource) }}</p>
          <p v-for="(item, index) in serverInfoList" :key="index">{{ item.label }}: {{ item.value }}</p>
        </template>
      </tooltip>
      <icon :type="`res-${type}`" @mouseover="handleMouseover" @mouseout="handleMouseout" />
      <icon v-if="type === 'vminstance' && dataSource.isolate_devices && dataSource.isolate_devices.length" type="res-gpu" style="position: absolute;left:55px;top:27px;width:10px;height:10px;border:none;" @mouseover="handleMouseover" @mouseout="handleMouseout" />
      <span class="name text-truncate" style="overflow:visible"><div class="text">{{ dataSource.name }}</div></span>
    </div>
    <span class="line" :style="isLast ? 'background:#fff!important;border:none' : ''" />
  </div>
</template>

<script>
import ResMixin from '@Network/sections/Topology/ResMixin'
import { sizestr } from '@/utils/utils'
import setting from '@/config/setting'
import Tooltip from './Tooltip'

export default {
  name: 'ResCommon',
  components: {
    Tooltip,
  },
  mixins: [ResMixin],
  props: {
    dataSource: {
      type: Object,
      default () {
        return {}
      },
    },
    type: {
      type: String,
    },
    showLeftLine: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      sizestr,
      tooltipShow: false,
    }
  },
  computed: {
    accountName () {
      const { id, name } = this.dataSource
      if (id === 'onecloud') {
        return setting.brand.en || name
      }
      return name
    },
    nameType () {
      if (this.type === 'vminstance') {
        return 'servers'
      }
      return 'gpu'
    },
    serverInfoList () {
      if (this.type !== 'vminstance') return []
      const { instance_type, tenant, isolate_devices = [] } = this.dataSource
      const ret = [
        { label: this.$t('compute.text_295'), value: instance_type },
        { label: this.$t('dictionary.project'), value: tenant },
      ]
      isolate_devices.forEach((item, index) => {
        ret.push({ label: this.$t('compute.text_113') + ' ' + (index + 1), value: item.name })
      })
      return ret
    },
  },
  methods: {
    getStatus ({ status, owner_status }) {
      if (!status && !owner_status) return this.$t('common.text00001')
      return this.$t(`status.server.${status || owner_status}`)
    },
    handleMouseover () {
      this.tooltipShow = true
    },
    handleMouseout () {
      this.tooltipShow = false
    },
    handleClick () {
      if (this.type === 'vminstance') {
        this.$router.push({
          path: '/vminstance',
          query: { id: this.dataSource.id },
        })
      } else if (this.type === 'gpu') {
        this.$router.push({
          path: '/gpu',
          query: { id: this.dataSource.id },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.wire {
  min-height: 120px!important;
  .vpc {
    min-height: 120px!important;
    .line {
      width: 80px !important;
    }
  }
}
.common {
  position: relative;
  .common-left-line {
    width: 2px;
    height: 120px;
    position: absolute;
    left: -2px;
    top: -118px;
    background: #2d3a4d;
  }
}
.pointer {
  cursor: pointer;
}
</style>
